<template>
  <div class="image-text-nav text-center" :style="{ backgroundColor, color }">
    <ul
      class="nav-list flex"
      :class="{ 'flex-wrap': imageTextNavList.length > 5 }"
    >
      <li
        class="flex-center nav-item fb24"
        v-for="(v, i) in imageTextNavList"
        :key="i"
      >
        <div class="nav-img-wrapper">
          <img class="img" :src="v.src" alt="导航" />
        </div>
        <span>{{ v.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "#fff"
    },
    color: {
      type: String,
      default: "#2b2b2b"
    },
    imageTextNavList: {
      type: Array,
      default: () => [
        {
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          title: "导航一"
        },
        {
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          title: "导航二"
        },
        {
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          title: "导航三"
        },
        {
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          title: "导航四"
        }
      ]
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.image-text-nav {
  font-size: 13px;
  padding: 16px 0;
}
.nav-list {
  margin-bottom: -20px;
}
.nav-img-wrapper {
  width: 45px;
  margin: 0 auto 10px;
  .img {
    border-radius: 5px;
    width: 100%;
  }
}

.nav-item {
  flex-basis: 20%;
  margin-bottom: 20px;
}
</style>
